import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { NAV } from "@/data/site";
import { Logo } from "@/components/Logo";
import { CtaLink } from "@/components/CtaLink";
import { MobileMenu } from "@/components/MobileMenu";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-paper/85 shadow-[0_1px_0_var(--line)] backdrop-blur-md" : "bg-paper"
      }`}
    >
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:rounded-full focus:bg-navy focus:px-4 focus:py-2 focus:text-white">
        Skip to content
      </a>
      <div className="shell flex h-20 items-center justify-between">
        <Link to="/" aria-label="PRPO LTD — home" data-testid="header-logo-link">
          <Logo />
        </Link>
        <nav aria-label="Primary" className="hidden lg:block">
          <ul className="flex items-center gap-1">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  data-testid={`nav-link-${item.testid}`}
                  className={({ isActive }) =>
                    `group relative flex items-center gap-2 rounded-full px-4 py-2 text-[0.92rem] font-medium transition-colors duration-300 ${
                      isActive ? "text-royal" : "text-navy/80 hover:text-navy"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className={`h-1.5 w-1.5 rounded-full bg-lime ring-1 ring-navy/20 transition-transform duration-300 ${isActive ? "scale-100" : "scale-0 group-hover:scale-100"}`} aria-hidden="true" />
                      {item.label}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex items-center gap-3">
          <CtaLink to="/contact" variant="navy" testid="header-start-project-button" className="hidden !py-2.5 md:inline-flex">
            Start a Project
          </CtaLink>
          <MobileMenu />
        </div>
      </div>
    </header>
  );
};
